import { siteKey } from '../app/apis';

const createNewRecaptchaToken = async (setToken) => {
  try {
    const verifyCallback = (generateToken) => generateToken;
    const action = 'submit';
    await window.grecaptcha.execute(siteKey, { action })
      .then((token) => {
        if (typeof verifyCallback !== 'undefined') {
          setToken(verifyCallback(token));
        }
      })
      .catch(() => {
        throw new Error('There was a problem in generating new recaptcha token.');
      });

    return Promise.resolve('done');
  } catch ({ message }) {
    return Promise.reject(message);
  }
};

export default createNewRecaptchaToken;
